// PulsanteBot.tsx — v041: per i tester, nei posti vuoti (1 contro 1, torneo a eliminazione, partita a 4) un bot
// al posto di una persona: si prova da soli la partita fino alla fine e alla condivisione. Testi del pannello (it/en).
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { caricaAdmin } from "../i18n/index.ts";

export function PulsanteBot({ tipo, onClick, disabled = false }: { tipo: "posto" | "gioca"; onClick: () => void; disabled?: boolean }) {
  const { t } = useTranslation("admin");
  const [pronto, setPronto] = useState(false);
  useEffect(() => {
    void caricaAdmin().then(() => setPronto(true));
  }, []);
  if (!pronto) return null;
  return (
    <button type="button" className={`pulsante ${tipo === "gioca" ? "pulsante-secondario" : "pulsante-piccolo"} ld-posto-bot`} title={t("prova.posto_bot_nota")} disabled={disabled} onClick={onClick}>
      {t(tipo === "gioca" ? "prova.gioca_bot" : "prova.posto_bot")}
    </button>
  );
}
